import { jwtDecode } from 'jwt-decode';
import { getTokenJWT } from '../api/ClientServicesCloud';

/**
 * Interfaccia che rappresenta un token JWT decodificato.
 *
 * @property {number} exp - Timestamp di scadenza del token.
 * @property {number} nbf - Timestamp prima del quale il token non è valido.
 * @property {string} ver - Versione del token.
 * @property {string} iss - Emittente del token.
 * @property {string} sub - Soggetto del token.
 * @property {string} aud - Destinatario del token.
 * @property {string} acr - Autenticazione context class reference.
 * @property {string} nonce - Valore unico per prevenire attacchi di replay.
 * @property {number} iat - Timestamp di emissione del token.
 * @property {number} auth_time - Timestamp del tempo di autenticazione.
 * @property {string} consumerRef - Riferimento del cliente.
 * @property {string} userRef - Riferimento dell'utente.
 * @property {string} workplaceRef - Riferimento del luogo di lavoro.
 * @property {string} sid - Session ID.
 * @property {string} data - Dati aggiuntivi.
 * @property {string[]} roles - Ruoli associati all'utente.
 * @property {string} tid - Tenant ID.
 */
interface DecodedTokenJWT_interface {
  exp: number;
  nbf: number;
  ver: string;
  iss: string;
  sub: string;
  aud: string;
  acr: string;
  nonce: string;
  iat: number;
  auth_time: number;
  consumerRef: string;
  userRef: string;
  userId: string;
  workplaceRef: string;
  accessLevel: 'workplace' | 'company';
  type: 'b2c' | 'impersonation';
  sid: string;
  data: string;
  roles: string[];
  tid: string;
}

const getDecodedJWTToken = (): DecodedTokenJWT_interface | null => {
  const token = getTokenJWT();

  if (!token) {
    return null;
  }

  try {
    return jwtDecode(token) as DecodedTokenJWT_interface;
  } catch (err) {
    console.error('[getDecodedJWTToken] Token JWT non valido:', err);
    return null;
  }
};

export default getDecodedJWTToken;
